import { showError } from '@/utils/utils'
import { useI18n } from 'vue-i18n'

export function useRequestConfig() {
  const { t } = useI18n();
  const ignore = _ => {};

  return {
    apiDownHandler: _ => showError(t('error.apiDown')),
    forbiddenHandler: ignore,
    unauthenticatedHandler: ignore,
    notFoundHandler: ignore,
    conflictHandler: ignore,
    badRequestHandler: ignore,
  };
}
